import axiosClient from "api/axiosInstance";
import { ClientCost, ClientCostRequest } from "api/models/ClientCost";

export const getClientCosts = async (
  clientId: number,
): Promise<ClientCost[]> => {
  const client = axiosClient();

  const response = await client.get(`/clients/${clientId}/costs/all`);

  return response.data.data;
};

export const createClientCost = async (
  clientId: number,
  data: ClientCostRequest,
): Promise<ClientCost> => {
  const client = axiosClient();

  const response = await client.post(`/clients/${clientId}/costs`, data);

  return response.data.data;
};

export const updateClientCost = async (
  clientId: number,
  costId: number,
  data: ClientCostRequest,
): Promise<ClientCost> => {
  const client = axiosClient();

  const response = await client.put(
    `/clients/${clientId}/costs/${costId}`,
    data,
  );

  return response.data.data;
};

export const deleteClientCost = async (
  clientId: number,
  costId: number,
): Promise<void> => {
  const client = axiosClient();

  await client.delete(`/clients/${clientId}/costs/${costId}`);
};
